/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Generalinquires1Inputs */

const en_titles_generalinquires1 = /** @type {(inputs: Titles_Generalinquires1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General inquires`)
};

/**
* | output |
* | --- |
* | "General inquires" |
*
* @param {Titles_Generalinquires1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_generalinquires1 = /** @type {((inputs?: Titles_Generalinquires1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Generalinquires1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_generalinquires1(inputs)
});
export { titles_generalinquires1 as "titles_generalInquires" }